export default __webpack_public_path__ + "static/nervous_system-1e5791a00fe2e444ca05a109d46886a9.jpg";